<div class="content-heading">
  <div class="header-container">
    <h3>Datos fiscales</h3>
    <small>Catálogo de datos fiscales</small>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-default">
        <div class="card-body">
          <div class="row mb-3">
            <div class="ml-auto mr-3 align-self-end">
              <aph-custom-buttons
                  type="button"
                  preset="refresh"
                  (btnClick)="refresh()"></aph-custom-buttons>
            </div>
            <div class="col-md-12">
              <app-ceq-table 
                #CeqGrid 
                [gridAdditionalOptions]="gridOptions" 
                [columnDef]="columnDefs" 
                (apiEmitter)="gridEmiter($event)">
              </app-ceq-table>
            </div>
          </div>

          <div class="row mt-3 align-items-center">
            <div class="col-md-auto d-flex align-items-center mb-2">
              <span class="mr-2">Tamaño de página:</span>
              <select class="form-control w-auto" (change)="onPageSizeChange($event.target.value)" [(ngModel)]="selectedSize">
                <option *ngFor="let size of PageSizes" [value]="size">{{size}}</option>
              </select>
            </div>
            
            <div class="mb-2 col-md-12">
              <aph-custom-buttons 
                preset="save" 
                label="Nueva configuración" 
                icon="fa fa-plus-circle"
                (btnClick)="btnAddClick()">
              </aph-custom-buttons>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>